import { styled } from '@mui/material/styles'

export const Iframe = styled('iframe')(() => ({
  width: '100%',
  height: '100%',
  border: 'none',
}))
